const CategoryResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'categories/',
        Object.assign(
            apiRequestParams.defaults(),
            {
                status: 'Active,Inactive,Archived',
            }
        )
    );
};

module.exports = CategoryResource;
